import { Box, Link, List, Typography, useMediaQuery } from '@material-ui/core'
import React from 'react'
import { useDispatch } from 'react-redux'
import { withdrawCookiesConsent } from '../../lib/helper/gdprHelper'
import { mobileBreakpoint } from '../../lib/helper/viewportHelper'
import { strings as Localization } from '../../lib/Localization'
import { useUserData } from '../../redux/hook/userHooks'
import theme from '../../theme'
import ListOptions from '../Navbar/ListOptions/ListOptions'
import UserInfo from '../UserInfo/UserInfo'
import useStyles from './styles'

const User = () => {
    const classes = useStyles()
    const userData = useUserData()
    const dispatch = useDispatch()
    const isMobile = useMediaQuery(theme.breakpoints.down(mobileBreakpoint))

    return (
        <Box className={classes.content}>
            <Typography variant='h3' gutterBottom>{`${Localization.hello} ${userData.name ?? ""}`}</Typography>
            <Box style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row' }}>
                <Box style={{ width: isMobile ? '100%' : '50%' }}>
                    <List className={classes.list} style={{ width: isMobile ? "100%" : 250 }}>
                        <ListOptions />
                    </List>
                </Box>
                <Box className={classes.userInfoBox} style={{ marginLeft: isMobile ? '16px' : '0px' }}>
                    <Box>
                        <UserInfo />
                    </Box>
                    <Box>
                        <Typography>
                            {Localization.ifYouWantToWithdrawConsent}
                            <Link onClick={() => dispatch(withdrawCookiesConsent())}>
                                {Localization.here}
                            </Link>.
                            {Localization.youMustThenAcceptTheTermsAgain}
                        </Typography>
                    </Box>
                </Box>
            </Box>
            <Typography className={classes.contactText} variant='caption'>
                {Localization.contactBroditVia}
                <a href='mailto:info@brodit.se'>info@brodit.se</a>
                {Localization.ifYouWantToChangeAnyInformation}
            </Typography>
        </Box>
    )
}

export default User
